export const axiosConfig = (method, url, data = undefined, isFormData = false, credentials = true) => {
  const config = {
    method,
    url,
  };

  if (data) {
    config.data = data;
  }

  if (credentials) {
    config.withCredentials = true;
  }

  if (isFormData) {
    config.headers = { "Content-Type": "multipart/form-data" };
  }

  return config;
};
